var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "identify-html-viewer bg-light" }, [
    _c("div", { domProps: { innerHTML: _vm._s(_vm.filteredResponse) } }),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }